import {createSelector} from 'reselect';
import GlobalState from '../../../root-state';

const selectOpenclose = (state : GlobalState) => state.hostess.openclose;

export const opencloseSelector = createSelector(
    [selectOpenclose],
    data => data
)
